import {createSelector} from 'reselect';
import {find} from 'lib/objectHelper';
import {
  getFirstSelectedCard,
  getSelectedCard,
  getTasksInCard,
  isConsolidateTipsCardExist,
} from '../../lib/cardAndTaskHelper';

export const getCards = (state) => state.cardState.cards;

export const getTasks = (state) => state.cardState.tasks;

export const getIsConsolidateTipsCardExist = createSelector(getCards, isConsolidateTipsCardExist);

export const getFirstSelectedCardSelector = (state) => getFirstSelectedCard(getCards(state));

export const getSelectedCardSelector = (state) => getSelectedCard(getCards(state));

export const getTasksInCardSelector = (card) => (state) => getTasksInCard(card, getTasks(state));

export const getOrderedTasksInCardSelector = (card) => (state) =>
  getTasksInCard(card, getTasks(state), {isReturnArray: true});

export const getCardById = (id) => (state) => getCards(state)[id];

export const getGroups = (state) => state.cardState.groups;

export const getGroupById = (id) => (state) => getGroups(state)[id];

export const getTasksByType = (type) => (state) => find(state.cardState.tasks, {type});
